module.exports = __webpack_public_path__ + "static/media/cooler_en.b5e4661b.png";